import type {ReactElement} from 'react';
import {getRegistrationButtonTextOptions, registerTextDropdownID} from '@Components/event-wizard/event-wizard-registrations/event-wizard-registrations.types';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItem3} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {getEventWizardRegistrationButtonText, getEventWizardRegistrationCustomButtonTexts} from '@Components/event-wizard/event-wizard.hooks';
import type {EventWizardRegistrationsButtonTextDropdownContentProps} from './event-wizard-registrations-button-text-dropdown-content.types';
import styles from './event-wizard-registrations-button-text-dropdown-content.module.scss';
import {useAppSelector} from '@/hooks';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';

export function EventWizardRegistrationsButtonTextDropdownContent({
  onClickOption,
  onClickCustomOption,
}: EventWizardRegistrationsButtonTextDropdownContentProps): ReactElement<any> {
  const getContentItems = (): ControlledListItem3[] => {
    const selectedRegistrationButtonText = useAppSelector(getEventWizardRegistrationButtonText);
    const customButtonTexts = useAppSelector(getEventWizardRegistrationCustomButtonTexts);

    return getRegistrationButtonTextOptions(customButtonTexts).map((registerText: string, index: number) => {
      return getContentItem(index, registerText, registerText === selectedRegistrationButtonText);
    });
  };

  const getContentItem = (index: number, registerText: string, isSelected: boolean): ControlledListItem3 => {
    return {
      id: `${index}_${registerText}`,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
      text: registerText,
      className: styles.listItem,
      isSelected,
      onClick(): void {
        onClickOption(registerText);
      },
    };
  };

  const getCustomTextContent = (): ReactElement<any> | undefined => {
    return (
      <ClickableDiv onClick={onClickCustomOption} className="flex-column-align-start">
        <hr className="border-s-standard _no-border-bottom _full-width radius-round spacing-m-t-2 spacing-m-b-0" />
        <div
          className={`${styles.listItem} ${styles.customListItem} radius-4 _full-width _cursor-pointer flex-row-align-center spacing-m-t-2 spacing-m-b-2 spacing-p-l-3 spacing-p-r-3`}
        >
          <Icon className="spacing-m-r-2" icon="icon-plus" size={IconSize.SIZE_ICON_16} />
          <Text val={window.i18next.t('pmwjs_add_custom_text')} size={TextSize.XSMALL} />
        </div>
      </ClickableDiv>
    );
  };

  return (
    <>
      <ControlledList className="spacing-m-0" id={registerTextDropdownID} items={getContentItems()} />
      {getCustomTextContent()}
    </>
  );
}
